import { render, staticRenderFns } from "./SyaratSOS.vue?vue&type=template&id=3ce21db0&scoped=true"
import script from "./SyaratSOS.vue?vue&type=script&lang=js"
export * from "./SyaratSOS.vue?vue&type=script&lang=js"
import style0 from "./SyaratSOS.vue?vue&type=style&index=0&id=3ce21db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce21db0",
  null
  
)

export default component.exports